import { Link } from 'react-router-dom';
import '../assets/css/cart_box.css';
import { MiniCart, Trash } from '../../assets/icones/icones';
import { useSelector, useDispatch } from 'react-redux';
import { decreaseQuantity, removeProduct, increaseQuantity } from '../../redux/cartredux/actions';
import {Fragment, useEffect, useState} from 'react';

import clientconfigwebapp, {
    empty_bk,
    check_login_appbk,
    FormatNumberByhkh,
    modal_login_reg_bk_show,
    modal_cart_show_hide,
    CalculateWith_tax_Percent,

} from '../../clientconfigwebapp';



const Card = (props) => {
    const cartItems = useSelector(state => state.cartItems);
    const totalPrice = useSelector(state => state.totalPrice);
    const dispatch = useDispatch();
    const [items , setItems] = useState([]);

    useEffect(() => {
        setItems([])
        setItems(cartItems);
    }, [cartItems]);


    const handleDecreaseQuantity = (productId) => {
        dispatch(decreaseQuantity(productId));
    };
    const handleIncreaseQuantity = (productId) => {
        dispatch(increaseQuantity(productId));
    };


    const handleRemoveProduct = (productId) => {
        dispatch(removeProduct(productId));
    };
    const clearCart = () => {
        items.map((item) => {
            dispatch(removeProduct(item.id));
        })
    }

    const Handler_login_show_bk = () => {
        modal_login_reg_bk_show("login_reg_check_view_modal");
    };

    const Handler_card_mobile_hide_bk = () => {
        modal_cart_show_hide("hide");
    };


    return (
        <>

            <button onClick={Handler_card_mobile_hide_bk} className={"btn-close-card-mobile"} style={{"backgroundColor":"transparent","border":"none","fontSize":"21px","marginBottom":"7px"}} type={"button"}>X</button>


            {items.length === 0 ? (
                <div className='empty-card flexColCenterCenter'>
                    <MiniCart />
                    <span style={{"fontFamily":"'kalameh'","paddingTop":"3px"}}>سبد خرید شما خالی است!</span>
                </div>
            ) : (
                <section className='card-container-b'>
                    <div className='w-100 card-wrapper'>
                        <div className='w-100 flexRowBetCenter card-header'>

                            <div style={{
                                "display": "flex",
                                "justifyContent": "flex-start",
                                "alignItems": "center",
                                "flexDirection": "row",
                                "flexWrap": "nowrap"
                            }}>
    <span className={"cart-icon-sidebar"} style={{"paddingLeft": "7px"}}><svg xmlns="http://www.w3.org/2000/svg"
                                                                              width="22" height="22" viewBox="0 0 22 22"
                                                                              fill="none">
<path
    d="M1.98278 15.9124C1.03185 12.1086 0.556385 10.2079 1.55497 8.92889C2.55245 7.6499 4.51416 7.6499 8.43426 7.6499H13.5657C17.4869 7.6499 19.4464 7.6499 20.445 8.92889C21.4436 10.2068 20.9681 12.1097 20.0172 15.9124C19.4121 18.3318 19.1106 19.541 18.2085 20.2459C17.3063 20.9496 16.0594 20.9496 13.5657 20.9496H8.43426C5.94056 20.9496 4.69371 20.9496 3.79154 20.2459C2.88938 19.541 2.58681 18.3318 1.98278 15.9124Z"
    stroke="#2A2621" stroke-width="1.5"/>
<path opacity="0.5"
      d="M19.3122 8.20411L18.5253 5.31696C18.2216 4.20311 18.0697 3.64673 17.7583 3.22668C17.4478 2.80937 17.0261 2.48789 16.5414 2.29903C16.0537 2.1084 15.4774 2.1084 14.3248 2.1084M2.6875 8.20411L3.4744 5.31696C3.77808 4.20311 3.92992 3.64673 4.24135 3.22668C4.55188 2.80937 4.9736 2.48789 5.45828 2.29903C5.94593 2.1084 6.52226 2.1084 7.6749 2.1084"
      stroke="#2A2621" stroke-width="1.5"/>
<path
    d="M7.6748 2.10831C7.6748 1.81437 7.79157 1.53247 7.99942 1.32462C8.20727 1.11677 8.48917 1 8.78312 1H13.2164C13.5103 1 13.7922 1.11677 14.0001 1.32462C14.2079 1.53247 14.3247 1.81437 14.3247 2.10831C14.3247 2.40225 14.2079 2.68416 14.0001 2.89201C13.7922 3.09985 13.5103 3.21662 13.2164 3.21662H8.78312C8.48917 3.21662 8.20727 3.09985 7.99942 2.89201C7.79157 2.68416 7.6748 2.40225 7.6748 2.10831Z"
    stroke="#2A2621" stroke-width="1.5"/>
</svg></span>
                                <span>سبد خرید ( {items.length} )</span>
                            </div>


                            <button className={"cart-trash-sidebar"} onClick={() => clearCart()}>
                                <Trash color={'var(--c7)'}/>
                            </button>
                        </div>
                        {items.map((item) => (
                            <div className='w-100 card-item' key={item.id}>
                                <h3>{item.title}</h3>
                                <div className='w-100 flexRowBetCenter'>
                                    <span className={"card-item-price"}>
                                        <span>{FormatNumberByhkh(String(item.price), ".", ",")}</span>
                                    </span>
                                    <div className='flexRowStartCenter'>
                                        <button
                                            onClick={() => item.quantity > 1 ? handleDecreaseQuantity(item.id) : handleRemoveProduct(item.id)}>-
                                        </button>
                                        <span>{item.quantity}</span>
                                        <button onClick={() => handleIncreaseQuantity(item.id)}>+</button>
                                    </div>
                                </div>
                            </div>
                        ))}
                        <div className='w-100 flexRowBetCenter card-footer card-footer-parta'>
                            <span className={"title-cart-parta"}>مجموع</span>
                            <span>
                              <span
                                  className={"price-total-cart-parta"}>{FormatNumberByhkh(String(totalPrice), ".", ",", "")}</span>
                            </span>
                        </div>


                        <div className='w-100 flexRowBetCenter  card-footer card-footer-partb'>
                            <span className={"title-cart-partb"}>ارزش افزوده</span>
                            <span>
                                <span
                                    className={"price-total-cart-partb"}>{FormatNumberByhkh(String(CalculateWith_tax_Percent(String(totalPrice),"percent_total")), ".", ",", "")}</span>
                            </span>
                        </div>


                        <div className='w-100 flexRowBetCenter  card-footer card-footer-partb'>
                            <span className={"title-cart-partb"}>قابل پرداخت</span>
                            <span>
                                <span
                                    className={"price-total-cart-partb"}>{FormatNumberByhkh(String(CalculateWith_tax_Percent(String(totalPrice),"plus_percent_total")), ".", ",", "")}</span>
                            </span>
                        </div>

                    </div>


                    {
                        check_login_appbk() === false ?

                            <>
                                <button type={"button"} onClick={Handler_login_show_bk} style={{
                                    "width": "100%",
                                    "marginTop": "8px",
                                    "height": "53px",
                                    "textAlign": "center",
                                    "display": "flex",
                                    "alignItems": "center",
                                    "justifyContent": "center",
                                    "fontSize": "16px"
                                }} to='/' className='btn-bh btn-bon-bh' >ورود به حساب کاربری</button>

                            </>
                            :
                            <>


                                { items.length > 0 ?  (

                                    <>
                                        <a href={clientconfigwebapp.webappurl + "checkout"} style={{"width":"100%","marginTop":"8px","height":"53px","textAlign":"center","display":"flex","alignItems":"center","justifyContent":"center","fontFamily":"'Kalameh'","fontSize":"17px"}}  className='btn-bh btn-bon-bh' >ادامه خرید</a>
                                    </>

                                ) : (
                                    <Fragment>
                                    </Fragment>

                                ) }





                            </>
                    }








                </section>
            )}
        </>
    )
}
export default Card;